<div class="dropdown">
  <button class="btn btn-primary input-group-btn dropdown-toggle" type="button" tabindex="0">
    {{ currentLimit || (allAvailable ? ('pagination.all' | translate) : '') }}
    <i class="fa fa-caret-down"></i>
  </button>
  <ul class="menu">
    <li *ngFor="let limit of availableLimits" class="menu-item" (mousedown)="onLimitClick(limit)">
      <a>
        {{ limit }}
      </a>
    </li>
  </ul>
</div>